import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--slider_item',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
      field_search_text: null,
      field_title: { value: 'I am a Slider Item', format: 'rich_text' },
    },
    relationships: {
      field_modules: {
        data: [],
      },
      field_tags: {
        data: [],
      },
    },
    links: {},
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
